<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_substitute" transform="translate(1348 2999)">
      <g id="그룹_8360" data-name="그룹 8360" transform="translate(249)">
        <rect
          id="사각형_5791"
          data-name="사각형 5791"
          fill-opacity="0"
          width="24"
          height="24"
          transform="translate(-1597 -2999)"
        />
        <g id="그룹_8345" data-name="그룹 8345" transform="translate(2 1)">
          <path
            id="사각형_5784"
            data-name="사각형 5784"
            fill="#087ef7"
            d="M2,0H16a2,2,0,0,1,2,2V5a0,0,0,0,1,0,0H0A0,0,0,0,1,0,5V2A2,2,0,0,1,2,0Z"
            transform="translate(-1596 -2996)"
          />
          <path
            id="사각형_5790"
            data-name="사각형 5790"
            fill="#d5d8dc"
            d="M0,0H18a0,0,0,0,1,0,0V12a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z"
            transform="translate(-1596 -2991)"
          />
          <rect
            id="사각형_5785"
            data-name="사각형 5785"
            fill="#363c43"
            width="2"
            height="4"
            transform="translate(-1593 -2998)"
          />
          <rect
            id="사각형_5786"
            data-name="사각형 5786"
            fill="#363c43"
            width="2"
            height="4"
            transform="translate(-1583 -2998)"
          />
        </g>
      </g>
      <g id="그룹_8365" data-name="그룹 8365">
        <path
          id="패스_4055"
          data-name="패스 4055"
          fill="#363c43"
          d="M14.66,8H9v5.66h2V11.42l2.95,2.95,1.41-1.41L12.41,10h2.24V8Z"
          transform="translate(-1349.77 -2996)"
        />
        <path
          id="패스_4058"
          data-name="패스 4058"
          fill="#363c43"
          d="M14.66,8H9v5.66h2V11.42l2.95,2.95,1.41-1.41L12.41,10h2.24V8Z"
          transform="translate(-1322.23 -2970.445) rotate(180)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
